
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    container: {
        padding: '10px',
    },
    root: {
        width: 65,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(38px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `0px solid ${theme.palette.grey[400]}`,
        backgroundColor: '#c3c3c3',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},

    alignItemsRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },

    mobileTableList: {
        display: 'flex',
        flexFlow: 'wrap',
        margin: '8px 0',
        background: '#F0F0F0',
        padding: '12px 5px',
        borderRadius: '10px',
        fontSize: '16px',
        "& div": {
            padding: '0 10px',
        },
        "&:nth-child(even)": {
            background: '#DCECFF',

        }
    },
    greyBorderBox: {
        border: '1px solid #e3e3e3',
        padding: '20px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: '5px',
        flexFlow: 'column',
        minHeight: '270px',
        borderRadius: '19px',
        "& h3": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: '39px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#3C4549',
            margin: '18px 0px',
        },
        "& img": {
            marginTop: '20px'
        }
    },
    table: {
        padding: '0px 20px',
    },
    changeBtn: {
        fontSize: window.isMobileView ? window.isMobile425 ? '8px' : '10px' : '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        backgroundColor: "#0049A3",
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px'
    },
    footerRight: {
        float: "center",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    backBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#0049A3',
        borderRadius: '4px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        textTransform: 'capitalize',
        border: '1px solid #0049A3',
        cursor: 'pointer',
    },

}))